module.exports = __webpack_public_path__ + "img/Teaching-Research Case - Dark Gray - Selected.95ec4aab.png";